import React, { Fragment, useRef, useState } from "react";
import Button, { UnionType } from "@common/components/Button";
import CustomDatePopover, {
  CustomDateFilter,
} from "@common/components/DatePopover";
import { UserWidgetEdit } from "@pages/Dashboard/WidgetEdit/reducer";

interface AssigneeButtonProps {
  buttonProps: UnionType;
  onFilterChange: (
    filterType: FilterTypes,
    filterValue: string,
    payload?: WidgetFilter["payload"]
  ) => void;
  filters: UserWidgetEdit["filters"];
  filterType?: string;
  filterTypeKey?: FilterTypes;
}
const TYPE: FilterTypes = "time";
const VALUE: MeetingsTimeFilter = "Custom time period";
const TimeButton = (props: AssigneeButtonProps) => {
  const {
    buttonProps,
    onFilterChange,
    filters,
    filterType,
    filterTypeKey = TYPE,
  } = props;
  const ref = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = () => {
    setOpen(true);
  };
  const onRemove = () => {
    onFilterChange(filterTypeKey, VALUE);
    setOpen(false);
  };

  const payload = filters?.find(
    (f) => f.filterValue === VALUE && f.filterType === filterTypeKey
  )?.payload as DateInterval | undefined;

  const timeFilter: CustomDateFilter = {
    label: "widget",
    getDates: () =>
      payload ?? {
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 7
        ).getTime(),
        endDate: new Date().getTime(),
      },
  };

  const isValidDateRange = (start: Date, end: Date) => {
    if (start > end) return false;
    // No range limit when querying audit trails
    if (!["Meetings", "Tickets"].includes(filterType ?? "")) return true;
    // 31 days range limit imposed by the backend when querying meetings and tickets
    const dayInMs = 60e3 * 60 * 24;
    const queryLimit = 31 * dayInMs;
    if (end.getTime() - start.getTime() > queryLimit) return false;
    return true;
  };
  return (
    <Fragment>
      <Button {...buttonProps} ref={ref} onClick={handleClick} />
      <CustomDatePopover
        anchorEl={ref.current}
        open={open}
        onClose={(payload) => {
          if (payload !== undefined)
            onFilterChange(filterTypeKey, VALUE, payload.getDates());
          setOpen(false);
        }}
        isValidRange={isValidDateRange}
        errorInvalidRange="Date range must not exceed 31 days"
        timeFilter={timeFilter}
        onRemove={onRemove}
      />
    </Fragment>
  );
};

export default TimeButton;
